var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('order-search'),_c('div',{staticClass:"container"},[_c('manager-decks')],1),(_vm.$auth.check(['admin', 'dispatcher']))?_c('div',{staticClass:"container"},[_c('partner-request-list')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }